<template>
  <div style="height:100%;" :style="{background:this.$store.state.pageBackground}">
    <router-view style="height:100%;"></router-view>
    <maintenance-notice></maintenance-notice>
  </div>
</template>

<script>

import windowsTips from '@/assets/imgs/windows-tips.png'
import macTips from '@/assets/imgs/mac-tips.png'
import { getOperatingSystem } from '@/utils'
import MaintenanceNotice from '@/module/home/components/maintenanceNotice.vue'

export default {
  components: {
    MaintenanceNotice
  },
  mounted: function() {
    // console.log('app',this.$store)
    this.updateTableHeight();

    window.onresize = () => {
      this.updateTableHeight();
    };

    /*
      如果是teams且没有弹出过且小屏
    */
    if (this.$store.state.hiddenHeader && !localStorage.getItem('tuituiDeviceTips') && document.body.clientWidth <= 1100) {
      const platform = getOperatingSystem()
      const tipsImg = platform === 'Windows'?windowsTips:macTips
      this.$message({
        customClass: 'teams-message',
        showClose: true,
        duration: 0,
        dangerouslyUseHTMLString: true,
        message: `<img width="365" src="${tipsImg}" />`
      });
      localStorage.setItem('tuituiDeviceTips',true)
    }
  
    
  },
  methods: {
    updateTableHeight() {
      var documentHeight = document.body.clientHeight;
      this.$store.commit("UPDATE_TABLE_HEIGHT", documentHeight - 270);
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// App.vue?6cef020f